import { SupportedEnvironments } from "@m4a3/api-client";

export const getEnvironment = (): SupportedEnvironments => {

  if (process.env.REACT_APP_ORDERFUL_URL.includes('dev')) {
    return 'dev'
  } else if (process.env.REACT_APP_ORDERFUL_URL.includes('uat')) {
    return 'uat'
  }

  // default to prod
  return 'prod'
};

export const getColourForEnvironment = (): string => {
  const environment = getEnvironment();

  if (environment === 'dev') {
    return 'yellow';
  } else if (environment === 'uat') {
    return 'red';
  }

  return 'white'
};
